<template>
  <el-date-picker
    v-model="date"
    type="date"
    :format="$t('base.dateFormat')"
    :picker-options="pickerOptions"
    :placeholder="placeholder"
    :disabled="disabled"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: "DatePickerInput",
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      required: true,
      default: ''
    },
    disabledDate: {
      type: Function,
      default: () => { }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: this.disabledDate
      }
    },
    date: {
      get() {
        return this.value && typeof this.value === 'string' ? new Date(this.value) : this.value
      },
      set(val) {
        this.$emit('input', val ? val.toString() : '')
      }
    }
  },
  mounted() {
    this.pickerOptions.firstDayOfWeek = parseInt(this.$t('base.dateFirstDayOfWeek'))
  }
}
</script>